import { ValueType } from '../../app/types';

interface ValueTypeDisplayProps {
  value: ValueType;
};

function ValueTypeDisplay(props: ValueTypeDisplayProps) {
  const { value } = props;
  switch (value) {
    case ValueType.Boolean:
      return (<span>Checkbox</span>);
    case ValueType.Integer:
      return (<span>Number</span>);
    case ValueType.Float:
      return (<span>Decimal</span>);
  }
  return <></>;
}

export default ValueTypeDisplay;